// extracted by mini-css-extract-plugin
export var active = "navigation-module--active--zAawn";
export var fadein = "navigation-module--fadein--emP6x";
export var navigation = "navigation-module--navigation--qe7Ve";
export var navigationItem = "navigation-module--navigationItem--NyZJ7";
export var wrapper = "navigation-module--wrapper--YafLz";